import React, { useState, useEffect } from 'react';

const pc = v => v == null ? '—' : (v >= 0 ? '+' : '') + Number(v).toFixed(1) + '%';

const DipSection = () => {
  const [slots, setSlots] = useState(null);
  const [dips, setDips] = useState([]);
  useEffect(() => {
    fetch('/stats/slots').then(r => r.ok ? r.json() : null)
      .then(j => j && setSlots(j)).catch(() => {});
    // own fetch: the panel's list is filtered by decision (default GO),
    // which would hide NO_GO DIP candidates. DIP ignores GO/NO_GO.
    fetch('/intelligence/stocks?limit=1000')
      .then(r => r.ok ? r.json() : null)
      .then(j => j && setDips((j.stocks || []).filter(x => x.setup_type === 'DIP')))
      .catch(() => {});
  }, []);

  return (
    <div style={{
      background: '#fffbf0', border: '1px solid #ffe7ba',
      borderRadius: 8, padding: 14, marginBottom: 16
    }}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 12, marginBottom: 4 }}>
        <span style={{ fontSize: 14, fontWeight: 700, color: '#ad6800' }}>
          📉 DIP CANDIDATES
        </span>
        <span style={{ fontSize: 12, color: '#ad6800' }}>{dips.length} today</span>
        {slots && (
          <span style={{ fontSize: 12, color: '#8c6d1f' }}>
            · slots {slots.dip.used}/{slots.dip.total}
            <span style={{ color: '#bbb' }}> | momentum {slots.momentum.used}/{slots.momentum.total}</span>
          </span>
        )}
      </div>
      <div style={{ fontSize: 11, color: '#8c6d1f', marginBottom: 10 }}>
        Up 20%+ over 20 days, prior day red. Enters only if today is down 0.5–4%.
        Framework VETO still applies; GO/NO_GO does not.
      </div>

      {dips.length === 0 ? (
        <div style={{ fontSize: 12, color: '#999' }}>
          No DIP candidates today — expected most days (~1–2/day).
        </div>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
          <thead>
            <tr style={{ color: '#8c6d1f', fontSize: 10, textTransform: 'uppercase' }}>
              <th style={{ textAlign: 'left', padding: '4px 8px' }}>Ticker</th>
              <th style={{ textAlign: 'left', padding: '4px 8px' }}>Sector</th>
              <th style={{ textAlign: 'left', padding: '4px 8px' }}>DVM</th>
              <th style={{ textAlign: 'right', padding: '4px 8px' }}>20d</th>
              <th style={{ textAlign: 'right', padding: '4px 8px' }}>Net</th>
              <th style={{ textAlign: 'left', padding: '4px 8px' }}>Framework</th>
              <th style={{ textAlign: 'left', padding: '4px 8px' }}>Trigger</th>
            </tr>
          </thead>
          <tbody>
            {dips.map(s => (
              <tr key={s.ticker} style={{ borderTop: '1px solid #ffe7ba' }}>
                <td style={{ padding: '5px 8px', fontWeight: 700 }}>{s.ticker}</td>
                <td style={{ padding: '5px 8px', color: '#666' }}>
                  {(s.sector || '').slice(0, 22)}
                </td>
                <td style={{ padding: '5px 8px', color: '#666' }}>
                  {(s.dvm_class || '').slice(0, 24)}
                </td>
                <td style={{ padding: '5px 8px', textAlign: 'right',
                             fontWeight: 700, color: '#389e0d' }}>
                  {pc(s.ret_20d)}
                </td>
                <td style={{ padding: '5px 8px', textAlign: 'right' }}>{s.net_conviction}</td>
                <td style={{ padding: '5px 8px' }}>
                  <span style={{
                    fontSize: 10, padding: '1px 6px', borderRadius: 4,
                    background: s.decision === 'GO' ? '#f6ffed' : '#f5f5f5',
                    color: s.decision === 'GO' ? '#389e0d' : '#8c8c8c'
                  }}>{s.decision}</span>
                </td>
                <td style={{ padding: '5px 8px', fontSize: 10, color: '#8c6d1f' }}>
                  {s.setup_reason}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default DipSection;
